module.exports = __webpack_public_path__ + "img/bus_black_circle.235dd24a.svg";